/* eslint-disable max-len */
/*
 *
 * AccountDeletion constants
 *
 */

export const ACCOUNT_DELETION_PROPS = {
  cardTitle: 'Contact Information',
  headerText: 'If you would like to delete your account, please call customer service for assistance.',
  hoursOfOperation: 'Monday - Friday, 8:00am - 7:00pm CST',
  title: 'Account Deletion',
};
